import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { theme } from 'Ui/theme';

const Terms = styled.div`
  font-family: var(--font-primary) !important;
  font-size: 1.2rem;
  color: ${theme.v2.text.darkGray};
  line-height: 1.6rem;
  margin: 1.6rem 0;
  a {
    color: var(--design-base-color) !important;
    text-decoration: underline !important;
  }
  @media screen and (min-width: ${theme.breakpoints.medium}px) {
    margin: 2.4rem 0;
  }
  .sentenceUnderAge {
    color: #4a4a4a;
    font-family: var(--font-primary);
    font-size: 1.2rem;
    font-weight: 400;
    line-height: 1.6rem;
    margin-top: 8px;
  }
`;

export const RegistrationTerms = () => {
  const { t } = useTranslation('header', { useSuspense: false });
  const translateHeader = {
    registrationTerms: {
      agreement: t('registrationTerms.agreement'),
      cgv: t('registrationTerms.cgv'),
      awareOf: t('registrationTerms.awareOf'),
      privacyPolicy: t('registrationTerms.privacyPolicy'),
      over16: t('registrationTerms.over16'),
    },
  };
  return (
    <Terms className="font-regular">
      <p style={{ marginBottom: '0.8rem' }}>
        {translateHeader.registrationTerms.agreement}{' '}
        <a
          href="https://fr.bazarchic.com/contenu/conditions-generales-de-ventes/"
          target="_blank"
          rel="noreferrer"
        >
          {translateHeader.registrationTerms.cgv}
        </a>
      </p>
      <p>
        {translateHeader.registrationTerms.awareOf}{' '}
        <a
          href="https://fr.bazarchic.com/contenu/politique-de-vie-privee/  "
          target="_blank"
          rel="noreferrer"
        >
          {translateHeader.registrationTerms.privacyPolicy}
        </a>
      </p>
      <p className="sentenceUnderAge">
        {translateHeader.registrationTerms.over16}
      </p>
    </Terms>
  );
};
